if (document.getElementById('vue-job-apply')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin ],
		el: '#vue-job-apply',
		data: {
			formFields: {
				position: {
					label: gettext('poste souhaité'),
					component: 'input',
					readonly: true,
					model: {}
				},
				first_name: {
					label: gettext('prénom'),
					component: 'input',
					model: {}
				},
				last_name: {
					label: gettext('nom'),
					component: 'input',
					model: {}
				},
				email: {
					label: gettext('email'),
					component: 'input',
					model: {}
				},
				phone_number: {
					label: gettext('téléphone'),
					component: 'input',
					model: {}
				},
				message: {
					label: gettext('votre message'),
					component: 'textarea',
					model: {}
				},
				cv: {
					label: gettext('CV'),
					placeholder: gettext('Ajouter un CV'),
					component: 'file',
					model: {}
				},
				cover_letter: {
					label: gettext('Lettre de motivation'),
					placeholder: gettext('Ajouter une lettre de motivation'),
					component: 'file',
					model: {}
				}
			},
			formDisabled: false
		},
		created() {
			this.$validator.localize('fr');
			this.$validator.extend('phone', MobileValidate);
			let params = getQueryStringParameters();
			if (params.hasOwnProperty('job')) {
				this.formFields.position.model.value = params.job;
			} else {
				this.formFields.position.model.value = gettext('Candidature spontanée');
			}
		},
		methods: {
			sendForm() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						// formdata.append('site_id', window.site_id);
						let formdata = new FormData();
						Object.keys(this.formFields).forEach((key) => {
							formdata.append(key, this.formFields[key].model.value);
						});
						this.post('job-postulation', formdata)
							.then((response) => {
								this.formDisabled = true;
							})
							.catch((error) => {
								// console.log(error);
								Object.keys(error.response.data).map((el) => {
									this.errors.remove(el);
									this.errors.add({
										field: el,
										msg: error.response.data[el][0]
									});
								});
							});
					}
				});
			}
		}
	});
}
